import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { scheduleAnalysesActions } from 'features/scheduleAnalyses';

const useScheduleAnalyses = () => {
  const dispatch = useDispatch();
  const getScheduleAnalyses = useCallback(({ offset }) => dispatch(scheduleAnalysesActions.getScheduleAnalyses({ offset })), [dispatch]);
  const getScheduleAnalysis = useCallback(({ id, cable }) => dispatch(scheduleAnalysesActions.getScheduleAnalysis({ id, cable })), [dispatch]);
  const clearLocalScheduleAnalyses = useCallback(() => dispatch(scheduleAnalysesActions.clearLocalScheduleAnalyses()), [dispatch]);
  const clearLocalActiveScheduleAnalysis = useCallback(() => dispatch(scheduleAnalysesActions.clearLocalActiveScheduleAnalysis()), [dispatch]);

  return {
    getScheduleAnalyses,
    getScheduleAnalysis,
    clearLocalScheduleAnalyses,
    clearLocalActiveScheduleAnalysis
  };
};

export default useScheduleAnalyses;